<template>
    <div class="product-preview-container" id="product-preview" :class="{'animateDisplay':isRecap}">
        <component :is="getTheSVG"></component>
    </div>
</template>


<script>
    import getAnswers from '@/lib/getAnswers';
    import aggregateAnswers from '@/lib/aggregateAnswers';
    import upperFirst from 'lodash/upperFirst'
    import camelCase from 'lodash/camelCase'


    export default {

        name: 'ProductPreview',
        components: {},
        computed: {
            getTheSVG() {
               return this.$store.state.productType
            },
            isRecap() {
                return parseInt(this.$route.params.step) === Object.keys(this.$store.state.steps).length
            }
        },
        methods: {
        },
        created() {
        }
    }
</script>


<style scoped>
    #product-preview{
        display: flex;
        align-items: center;
        justify-content: center;
        max-height: 175px;
        margin-bottom: 5%;
        width: 100%;
        transition: all .5s;
    }

    #product-preview.animateDisplay{
        /* animation-duration: .5s;
        animation-name: displayNoneHeight; */
        transition: all .5s;
        height: 0%;
        overflow: hidden;
        margin-bottom: 0%;
    }
    /* @keyframes displayNoneHeight{
        0%{
            opacity: 1;
            height: 100%;
        }
        100%{
            opacity: 0;
            height: 0%;
        }
    } */
    @media screen and (max-width: 767px) {
        #product-preview{
            height: 50%;
        }
    }
</style>
